import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<circle cx="16" cy="16" r="16" fill="#CCF2F1" key="0" />,<path fill="#2B2B2B" d="M8 12h14v-2H8zm0 14q-.825 0-1.4125-.5875T6 24V10q0-.825.5875-1.4125T8 8h1V6h2v2h8V6h2v2h1q.825 0 1.4125.5875T24 10v5.675a6.9 6.9 0 0 0-.975-.375q-.5-.15-1.025-.225V14H8v10h6.3q.175.55.4125 1.05t.5625.95zm13 1q-2.075 0-3.5375-1.4625T16 22t1.4625-3.5375T21 17t3.5375 1.4625T26 22t-1.4625 3.5375T21 27m1.675-2.625.7-.7L21.5 21.8V19h-1v3.2z" key="1" />,]
, 'DisplayScheduleCalendarFilledx');
